<template>
  <div class="register-container">
    <Loading v-if="$store.state.loading" />
    <Alert v-if="$store.state.alert" />
    <div class="register-content">
      <div>
        <img
          src="../../../assets/img/logo-merah.png"
          class="register-logo"
          alt=""
        />
      </div>
      <div class="reg-google-header">
        <div class="welcome-text">Selamat Datang</div>
        <div class="sub-welcome-text">
          Silakan masukkan informasi Anda
        </div>
      </div>

      <div class="register-form-container">
        <div class="register-form-wrapper">
          <div>
            <div class="register-input-field">
              <div class="register-input-label">Nama</div>
              <input
                type="text"
                class="register-input"
                placeholder="Masukkan Nama"
                v-model="nama"
              />
            </div>
            <div class="register-input-field">
              <div class="register-input-label">Company</div>
              <input
                type="text"
                class="register-input"
                placeholder="Masukkan Nama Company"
                v-model="company"
              />
            </div>
            <div style="margin-top: 12px;">
              <div class="reg-google-btn" @click="toogleForm">Kirim</div>
            </div>
          </div>
          <div class="email-sipm">
            <p>
              Jika mengalami kendala, mohon dapat menghubungi email
              <a href="#">SIPM_Member_Team@sinarmasmining.com</a>
            </p>
          </div>
        </div>
      </div>
      <ModalSuccess
        v-if="isModalSuccess"
        :modalText="modalText"
        @closeModalSuccess="closeModalSuccess"
      />
    </div>
  </div>
</template>
<script>
import { api } from '../../services/config'
import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    Alert: () => import('@/components/Modal/Alert'),
    ModalSuccess: () => import('@/components/ModalSuccess.vue'),
  },
  data() {
    return {
      email: '',
      nama: '',
      company: '',
      password: '',
      confPassword: '',
      showForm: false,

      modalText: 'Silahkan tunggu email dari SIPM',
      isModalSuccess: false,
      token: '',
      id: '',
    }
  },
  async created() {
    const self = this
    let token = self.$router.currentRoute.query.token
    if (token) {
      const dec = VueJwtDecode.decode(token)
      this.token = token
      this.id = dec.id
      console.log('token', this.id, token)
    }
  },
  methods: {
    async openModalSuccess() {
      // this.isModalSuccess = true

      console.log('run google login')
      const self = this
      const url = `${api}/api/v1/auth/google-register`

      this.$store.commit('setLoading', true)
      try {
        const { data: auth } = await axios({
          method: 'GET',
          url,
        })

        if (auth) {
          console.log('data login: ', auth)
          this.$store.commit('setLoading', false)
          //   this.$router.push({ name: 'home' }, () => {})
          window.open(auth, '_self')
        }
      } catch (error) {
        console.log('error', error)
        this.$store.commit('setLoading', false)

        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Server Error')
        )
      }
    },

    closeModalSuccess() {
      this.isModalSuccess = false
      this.$router.push('/')
    },

    async submitForm() {
      this.$store.commit('setLoading', true)
      try {
        let update = {
          name: this.nama,
          company_name: this.company,
          is_register: true,
        }
        if (this.password != '') {
          update.password = this.password
        }

        const { data } = await axios({
          method: 'PUT',
          url: `${process.env.VUE_APP_API}/api/v1/user/${this.id}`,
          data: update,
        })

        if (data && data.status == 'success') {
          this.$store.commit('setLoading', false)
          this.isModalSuccess = true
        }
      } catch (error) {
        console.log('error: ', error)
        this.$store.commit('setLoading', false)
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    toogleForm() {
      if (this.nama != '' && this.company != '') {
        if (this.password != '' || this.confPassword != '') {
          if (this.password != this.confPassword) {
            this.$store.commit(
              'SET_NOTIF',
              'Password dan Confirm Password tidak sama'
            )
          } else {
            this.submitForm()
          }
        } else {
          this.submitForm()
        }
      } else {
        this.$store.commit('SET_NOTIF', 'Nama dan Company tidak boleh kosong')
      }
    },
  },
}
</script>
